export function OptionStockDistributionValue({
  opticName,
  value,
  onInc,
  onDec,
  onChangeValue,
  index,
  maxStock,
}) {
  return (
    <div
      key={index}
      style={{
        display: "flex",
        gap: "5px",
        border: "1px solid #afafaf",
        padding: "5px",
        borderRadius: "5px",
        backgroundColor: "whitesmoke",
      }}
    >
      <span index={index}>{opticName}</span>
      <button className="incdec-btn" onClick={() => onDec(index)}>
        -
      </button>
      <input
        value={value}
        style={{ textAlign: "center" }}
        max={maxStock}
        onChange={onChangeValue}
      ></input>

      <button className="incdec-btn" onClick={() => onInc(index)}>
        +
      </button>
    </div>
  );
}
